import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonMode,
  DocumentIcon,
  DownloadIcon,
  Popover,
  PagePanel,
  ButtonSize,
  NotificationType,
  Notification
} from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { routerPaths } from '@epi-constants/routerPaths';

import { IngestroImporter, IngestroError } from './components';
import { FileFormatButton } from './ImportEmployees.styles';
import { useImportEmployees } from './useImportEmployees';

export const ImportEmployees = () => {
  const { primaryFrontColor } = useTheme();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [ingestroError, setIngestroError] = useState<Error | null>(null);
  useImportEmployees({
    ingestroError,
    setIngestroError
  });

  const isPopoverOpen = Boolean(anchorEl);

  const openDropdown = event => {
    setAnchorEl(event.currentTarget);
  };
  const closeDropdown = () => setAnchorEl(null);

  return (
    <PagePanel
      title={t('containers.beneficiaries.import_employees.title')}
      backIcon
      backIconLink={routerPaths.beneficiaries}
      headerContent={
        ingestroError ? null : (
          <Button
            id="download-template-button"
            mode={ButtonMode.Secondary}
            size={ButtonSize.Medium}
            onClick={openDropdown}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <DownloadIcon />
              {t('containers.beneficiaries.import_employees.download_button')}
            </Box>
          </Button>
        )
      }
    >
      {ingestroError && <IngestroError />}
      <Box display={ingestroError ? 'none' : undefined}>
        <Box pb={6}>
          <Notification
            id="import-employees-info"
            type={NotificationType.Info}
            text={t('containers.beneficiaries.import_employees.info')}
          />
        </Box>
        <Popover
          open={isPopoverOpen}
          anchorEl={anchorEl}
          onClose={closeDropdown}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          disableAutoFocus
        >
          <Box display="flex" flexDirection="column">
            <FileFormatButton
              id="file-format-button-xlxs"
              mode={ButtonMode.None}
            >
              <Box display="flex" gap={1.5} py={1} px={2}>
                <DocumentIcon color={primaryFrontColor} />
                {t(
                  'containers.beneficiaries.import_employees.file_format.xlxs'
                )}
              </Box>
            </FileFormatButton>
            <FileFormatButton
              id="file-format-button-csv"
              mode={ButtonMode.None}
            >
              <Box display="flex" gap={1.5} py={1} px={2}>
                <DocumentIcon color={primaryFrontColor} />
                {t('containers.beneficiaries.import_employees.file_format.csv')}
              </Box>
            </FileFormatButton>
          </Box>
        </Popover>
        <IngestroImporter />
      </Box>
    </PagePanel>
  );
};
